export const ErrorEvent = {
    GetAppliedLabelError: 'GetAppliedLabelError',
    GetDlpPolicyTipError: 'GetDlpPolicyTipError',
    GetIrmCapabilitiesError: 'GetIrmCapabilitiesError',
    GetLabelsError: 'GetLabelsError',
    GetPolicySettingsError: 'GetPolicySettingsError',
    GetWatermarkingError: 'GetWatermarkingError',
    InvalidResolvedUrl: 'InvalidResolvedUrl',
    InvalidTenantId: 'InvalidTenantId',
    RemoveLabelError: 'RemoveLabelError',
    SetLabelError: 'SetLabelError',
    EnforceInformationProtectionError: 'EnforceInformationProtectionError'
};
//# sourceMappingURL=ErrorEvent.js.map